export default "/images/crm-dark.svg?ca0b41403d32382523cc0d2703b3c39b";